export function fmtNum(n: number): string {
    return n.toLocaleString('de-CH');
}

export function fmtDate(iso: string | null | undefined): string {
    if (!iso) return '—';
    const d = new Date(iso);
    return Number.isFinite(d.getTime()) ? d.toLocaleDateString('de-CH') : '—';
}

export function fmtDateTime(iso: string | null | undefined): string {
    if (!iso) return '—';
    const d = new Date(iso);
    return Number.isFinite(d.getTime())
        ? `${d.toLocaleDateString('de-CH')} ${d.toLocaleTimeString('de-CH', { hour: '2-digit', minute: '2-digit' })}`
        : '—';
}

/** Color class for the "days since last view" badge: green <30, amber 30-90, red >90/never. */
export function lastViewBadgeClass(daysSince: number | null): string {
    if (daysSince === null) return 'border-red-200 bg-red-50 text-red-700';
    if (daysSince < 30) return 'border-green-200 bg-green-50 text-green-700';
    if (daysSince <= 90) return 'border-amber-200 bg-amber-50 text-amber-700';
    return 'border-red-200 bg-red-50 text-red-700';
}
